'use client';
import { jsx } from 'react/jsx-runtime';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';
import { RenderComp } from '../core/render-comp.component.js';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const ToggleSwitchSize = {
    Standard: 'standard',
    Super: 'super',
    Mini: 'mini'
};
const ToggleSwitch = renderWithRef('ToggleSwitch', null, (r, s)=>{
    useDeprecatedProps('ToggleSwitch', r, [
        {
            propName: 'size',
            instructions: 'Sizing is now handled automatically by standardMode/compactMode'
        }
    ]), useComponentStylesLoaded('ToggleSwitch', SWAN_STYLE_KEY_MAP.toggleSwitch);
    let { hideText: p = false, size: l = 'standard', defaultActivated: u = false, activated: d, onRequestActivatedChange: f, children: b } = r, g = _object_without_properties(r, [
        "hideText",
        "size",
        "defaultActivated",
        "activated",
        "onRequestActivatedChange",
        "children"
    ]), [w, h] = useControllableValue({
        value: d,
        onChange: f || void 0,
        defaultValue: u,
        defaultOnChange: (e, ...t)=>{
            let [r] = t;
            e(r);
        }
    }), m = new Set([
        'swan-vanilla-ignore',
        'swan-toggle-switch'
    ]);
    return 'mini' === l && m.add(`swan-toggle-switch-${l}`), 'super' === l && m.add(`swan-toggle-switch-${l}`), p && m.add('swan-toggle-switch-hide-text'), jsx(RenderComp, {
        root: "button",
        forwardedRef: s,
        classNames: m,
        props: _object_spread_props(_object_spread({}, g), {
            role: 'switch',
            'aria-checked': !!w,
            onClick: composeEventHandlersUtil(r.onClick, (e)=>{
                h(!w, e);
            })
        }),
        children: b
    });
});

export { ToggleSwitch, ToggleSwitchSize };
